const ERP = (
    <div className='md:w-4/5 mx-auto py-10 text-lg'>
        <h1 className='text-2xl font-bold'>
            ERP
        </h1>
        <br />
        <div className='md:px-5 text-gray-500'>
            <p>SAP ERP Central Component is the company&#39;s on-premises, stalwart ERP system, and it includes
                supply chain management, product lifecycle management, human capital management,
                financial management and customer relationship management software. Most simply refer to it
                as SAP ERP. It can be deployed on premises on a company&#39;s own infrastructure, with an IaaS
                provider or in a private cloud option. SAP does enable companies to migrate SAP ERP software
                to the cloud by converting to SAP S/4HANA, which runs as PaaS.
            </p>
            <br />
            <p>SAP ERP&#39;s maturity is its strength. More than 170,000 businesses worldwide use it as of 2018,
                and SAP customized it to support 25 different industry verticals and 37 different languages. This
                makes an SAP ERP system appealing to companies with global business dealings and companies
                in specialized industries with highly specific needs.
            </p>
            <br />
            <p>At the time of this writing, the latest release of SAP ERP is Enhancement Package 8 for ERP 6.0,
                Support Package Stack (SPS) 7. SPS 7 delivers logistics improvements, including enhanced
                functionality to SAP Retail and Plant Maintenance, as well as an update to the Data Controller
                Rule Framework that ensures personal data is stored according to legal requirements and
                complies with general data privacy acts. Additionally, Package 8 as a whole enhanced existing
                financial, retail, wholesale, logistics and plant maintenance functionality. Release 6.0 also
                delivered new hedging functionality for companies managing multicurrency environments.
                Additionally, Release 6.0 included embedded geospatial technology, which adds locational
                analytics for business operations.
            </p>
            <br />
            <p>What&#39;s important to note is that SAP Enhancement Package 7 for ERP 6.0 is required before a
                move to SAP HANA, SAP&#39;s in-memory database platform. SAP Enhancement Packages are
                designed to let companies add functionality as needed, while SPS releases are patches and
                updates that are designed to be implemented together.
            </p>
            <br />
            <p>SAP ERP software is available on a price-quote basis, as a traditional, on-premises system,
                licensed on a perpetual named-user basis from SAP directly or as SAP Business All-in-One
                software via an SAP reseller.
            </p>
        </div>
    </div>
)

export default ERP